import { IIcon } from './iconConstants'
const MobileIcon = ({ width, height, fill }: IIcon) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 52 53'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#tdn0y28pba)'>
        <path
          d='M38.997.5a5.2 5.2 0 0 1 5.2 5.2v41.6a5.2 5.2 0 0 1-5.2 5.2h-26a5.2 5.2 0 0 1-5.2-5.2V5.7a5.2 5.2 0 0 1 5.2-5.2h26zm1.56 40.009h-29.12V47.3a1.56 1.56 0 0 0 1.56 1.56h26a1.56 1.56 0 0 0 1.56-1.56v-6.791zM25.997 42.1a2.6 2.6 0 1 1 0 5.2 2.6 2.6 0 0 1 0-5.2zm13-37.96h-26a1.56 1.56 0 0 0-1.56 1.56v31.169h29.12V5.7a1.56 1.56 0 0 0-1.56-1.56z'
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id='tdn0y28pba'>
          <path fill={fill} transform='translate(0 .5)' d='M0 0h52v52H0z' />
        </clipPath>
      </defs>
    </svg>
  )
}
export default MobileIcon
